import { Component } from 'react';
import PropTypes from 'prop-types';
import { logError, ERROR_TYPES } from 'helpers/wkda-logger';

class ErrorBoundaryLogger extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error) {
    logError({
      type: ERROR_TYPES.react,
      error,
      referrer:
        typeof window !== 'undefined' ? window.location.href : undefined,
    });
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}

export default ErrorBoundaryLogger;
